<template>
  <div>
    <!-- main-area -->
    <main class="fix">
      <!-- breadcrumb-area -->
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb__content">
                <h2 class="title">Anggota Komisi</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Komisi</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Anggota Komisi</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>

      <section class="services__details-area">
        <div class="container">
          <div class="services__details-wrap">
            <div class="row">
              <div class="col-70 order-0 order-lg-2">

                <div class="row">
                  <h5 class="mb-3">Anggota {{ komisiLabel }}</h5>
                  <div class="row">
                    <div class="col-md-4 mb-4" v-for="d in list_data" :key="d.id">
                      <div class="team__item-two text-center">
                        <div class="team__thumb-two shine-animate" @click="selectData(d)" data-bs-toggle="modal"
                          data-bs-target="#modalKomisi" style="cursor: pointer;">
                          <img :src="getFoto(d)" alt="Foto Anggota Komisi" @error="$event.target.src='assets/img/user.png'" />
                        </div>
                        <div class="team__content-two">
                          <h5 class="title">{{ d.nama }}</h5>
                          <span>{{ d.jabatan_komisi }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="list_data.length === 0" class="text-center text-muted">
                      <p>Data tidak ditemukan.</p>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-30">
                <aside class="services__sidebar">
                  <div class="sidebar__widget sidebar__widget-two">
                    <div class="mb-3">
                      <label for="filterMasaJabatan" class="form-label fw-bold">Pilih Masa Jabatan:</label>
                      <select id="filterMasaJabatan" class="form-select" v-model="masa_jabatan_selected"
                        @change="getAnggotaKomisi">
                        <option v-for="m in list_masa_jabatan" :key="m.id" :value="m.id">
                          {{ m.label }}
                        </option>
                      </select>
                    </div>
                    <div class="sidebar__cat-list-two">
                      <ul class="list-wrap">
                        <li v-for="kom in list_komisi" :key="kom.id" :class="{ active: komisi_selected === kom.id }">
                          <a href="javascript:void(0)" @click="filterByKomisi(kom.id)">
                            {{ kom.nama }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>




                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>

  <!-- Modal Detail Dewan -->
  <!-- Modal Detail Dewan -->
  <div class="modal fade" id="modalKomisi" tabindex="-1" aria-labelledby="modalKomisiLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow-lg">
        <div class="modal-header text-white">
          <h5 class="modal-title" id="modalKomisiLabel">{{ form.nama }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- Foto -->
            <div class="col-md-5 text-center mb-3 mb-md-0">
              <img :src="getFoto(form)" alt="Foto Detail" class="img-fluid rounded shadow-sm"
                style="max-height: 300px; object-fit: cover;" @error="$event.target.src='assets/img/user.png'" />
            </div>

            <!-- Info Detail -->
            <div class="col-md-7">
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Jabatan DPRD:</strong>
                  <span>{{ form.jabatan_dprd }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Jabatan Komisi:</strong>
                  <span>{{ form.jabatan_komisi }} - {{ komisiLabel }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Daerah Pemilihan:</strong>
                  <span>{{ form.dapil }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Tempat, Tanggal Lahir:</strong>
                  <span>{{ form.ttl }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Agama:</strong>
                  <span>{{ form.agama }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Alamat:</strong>
                  <span>{{ form.alamat }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <strong>Partai:</strong>
                  <span>{{ form.nama_partai }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>






</template>

<script>
export default {
  data() {
    return {
      form: {
        id: '',
        nama: '',
        dapil: '',
        jabatan_dprd: '',
        jabatan_komisi: '',
        uraian: '',
        nama_partai: '',
        foto: '',
        unit_kerja: '',
        status: '',
        keterangan: '',
      },
      fraksi_id_selected: "",
      list_data: [],
      list_data_fraksi: [],
      page_first: 1,
      page_last: 0,
      perPage: 12,
      masa_jabatan: "",
      selectedDewan: null,

      cari_value: "",
      file_path: this.$store.state.URL_APP + "uploads/",
      masa_jabatan_selected: "",
      list_masa_jabatan: [],




      list_komisi: [
        { id: 'KOMISI I', nama: 'Komisi I' },
        { id: 'KOMISI II', nama: 'Komisi II' },
        { id: 'KOMISI III', nama: 'Komisi III' }
      ],

      komisi_selected: 'KOMISI I',
      anggotaKomisi: [],
    };
  },

  computed: {

    komisiLabel() {
      return this.list_komisi.find(k => k.id === this.komisi_selected)?.nama || '';
    },
    sortedAnggota() {
      const jabatanOrder = {
        'Ketua Komisi': 1,
        'Wakil Ketua Komisi': 2,
        'Sekretaris Komisi': 3,
        'Anggota': 4,
      };

      return this.anggotaKomisi
        .filter(d =>
          d.komisi === this.komisi_selected &&
          d.masa_jabatan === this.masa_jabatan_selected
        )
        .map(d => ({
          ...d,
          jabatan_label: this.formatJabatan(d.jabatan_komisi),
        }))
        .sort((a, b) => {
          return jabatanOrder[a.jabatan_label] - jabatanOrder[b.jabatan_label];
        });
    },
  },

  methods: {

    openModal(data) {
      if (!data) {
        console.warn("Data tidak tersedia");
        return;
      }
      this.selectData(data); // Mengisi form modal dengan data
    },

    filterByKomisi(id) {
      this.komisi_selected = id;
      this.getAnggotaKomisi();
    },

    getFoto(item) {
      if (!item || !item.file) {
        return 'assets/img/user.png'; // fallback gambar default
      }
      return this.file_path + item.file;
    },


    // getAnggotaKomisi() {
    //   fetch(this.$store.state.ADD_URL_KOMISI + "view", {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({ data_ke: 1 }),
    //   })
    //     .then((res) => res.json())
    //     .then((res_data) => {
    //       this.anggotaKomisi = res_data.data || [];
    //     })
    //     .catch((err) => {
    //       console.error("Gagal ambil data komisi:", err);
    //     });
    // },



    getView() {

      fetch(this.$store.state.ADD_URL_DEWAN + "view", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          masa_jabatan: this.masa_jabatan_selected,
          fraksi_id: this.fraksi_id_selected
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_data = res_data.data || [];

          const total = res_data.total_data || 0;
          const per_page = res_data.per_page || 12;
          this.page_last = Math.ceil(total / per_page) || 1;
        })
        .catch((err) => {
          console.error("Gagal ambil data:", err);
        });
    },

    getListKomisi() {
      fetch(this.$store.state.ADD_URL_KOMISI + "view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data_ke: 1 }),
      })
        .then(res => res.json())
        .then(data => {
          this.list_komisi = data || [];
          if (this.list_komisi.length) {
            this.komisi_selected = this.list_komisi[0].id;
          }
          this.getAnggotaKomisi();
        });
    },

    getAnggotaKomisi() {

      if (!this.komisi_selected || !this.masa_jabatan_selected) return;

      fetch(this.$store.state.ADD_URL_KOMISI + "view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          komisi_id: this.komisi_selected,
          masa_jabatan_id: this.masa_jabatan_selected,
        }),
      })
        .then(res => res.json())
        .then(data => {
          this.list_data = data || [];
        });
    },

    getMasaJabatan() {
      fetch(this.$store.state.ADD_URL_MASA_JABATAN + "view", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data_ke: 1 }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.list_masa_jabatan = res_data.data || [];
          const masaDefault = this.list_masa_jabatan.find(
            (masa) => masa.label === "2024 - 2029"
          ) || this.list_masa_jabatan[0];
          if (masaDefault) {
            this.masa_jabatan_selected = masaDefault.id;
          }

          this.getAnggotaKomisi();
        })
        .catch((err) => {
          console.error("Gagal ambil masa jabatan:", err);
        });
    },

    selectData: function (data) {
      this.form = {
        id: data.id,
        nama: data.nama,
        jabatan_dprd: data.jabatan_dprd || '-',
        jabatan_komisi: data.jabatan_komisi || '-',
        ttl: data.ttl || '-',
        partai: data.partai || '-',
        dapil: data.dapil || '-',
        agama: data.agama || '-',
        alamat: data.alamat || '-',
        nama_partai: data.nama_partai || '-',
        file: data.file,
      };
    },

    btn_prev() {
      if (this.page_first > 1) {
        this.page_first--;
        this.getView();
      }
    },
    btn_next() {
      if (this.page_first < this.page_last) {
        this.page_first++;
        this.getView();
      }
    },
    go_to_page(page) {
      if (page !== "...") {
        this.page_first = page;
        this.getView();
      }
    },
    onChangeMasaJabatan() {
      this.getAnggotaKomisi();
    }
  },

  mounted() {
    this.getMasaJabatan();
  }
};
</script>